import React from 'react';
import PropTypes from 'prop-types';
import {
    PlayerDuelWrapper,
    MatchupWrapper
} from './GameContextPlayerDuel.style';
import {
    MatchupStateWrapper
} from './PlayerDuel.style';
import Outs from './components/Outs';
import buildMatchupState from './utils/buildMatchupState';
import BasePathComponent, { BASEPATH_WIDTH, BASEPATH_MOBILE_WIDTH } from './components/BasePathComponent';
import MatchupsList from './components/MatchupsList';

const GameContextPlayerDuel = ({
    probablePitchers,
    abstractGameCode,
    batter,
    first,
    second,
    third,
    pitcher,
    balls,
    strikes,
    outs,
    gameStateOverride,
    deviceInteraction,
    usePreviousPlayers,
    headshotWidth,
    isMobile
}) => {
    const gameCodeOverride = gameStateOverride || abstractGameCode;
    const matchupState = buildMatchupState({ gameCodeOverride, balls, strikes });
    const basepaths = { first: !!first?.person, second: !!second?.person, third: !!third?.person };
    const isPreview = abstractGameCode === 'P' || gameCodeOverride === 'P';
    const matchupsArray = MatchupsList({
        probablePitchers,
        abstractGameCode,
        batter,
        pitcher,
        gameStateOverride,
        stacked: true,
        deviceInteraction,
        usePreviousPlayers,
        isMobile: true,
        isFullNarrow: false,
        headshotWidth,
        showCustomPlayerInfo: false,
        viewType: 'condensed'
    });

    const outWidth = isMobile ? BASEPATH_MOBILE_WIDTH : BASEPATH_WIDTH;

    return (
        <>
            <PlayerDuelWrapper >
                { matchupsArray.length && (
                    <MatchupWrapper >
                        { matchupsArray[0] }
                        <MatchupStateWrapper >
                            {!isPreview &&
                            <>
                                <BasePathComponent {...basepaths} width={outWidth} activeColor={'var(--gameday-game-context-primary)'} />
                                <span>{matchupState}</span>
                                <Outs outCount={outs} outWidth={outWidth} activeColor={'var(--gameday-game-context-primary)'}/>
                            </>}
                        </MatchupStateWrapper>
                        { matchupsArray[1] }
                    </MatchupWrapper>
                )}
            </PlayerDuelWrapper>
        </>
    );
};

GameContextPlayerDuel.propTypes = {
    data: PropTypes.object,
    probablePitchers: PropTypes.object,
    abstractGameCode: PropTypes.string,
    batter: PropTypes.object,
    inHole: PropTypes.object,
    onDeck: PropTypes.object,
    first: PropTypes.bool,
    second: PropTypes.bool,
    third: PropTypes.bool,
    pitcher: PropTypes.object,
    balls: PropTypes.string,
    strikes: PropTypes.string,
    outs: PropTypes.number,
    gameStateOverride: PropTypes.string,
    deviceInteraction: PropTypes.object,
    usePreviousPlayers: PropTypes.bool,
    headshotWidth: PropTypes.string,
    isMobile: PropTypes.bool
};

export default GameContextPlayerDuel;
